import React, { useMemo, useState } from 'react';

export const STAT_COLUMNS = [
  { key: 'contacted', label: 'Contacted' },
  { key: 'qc', label: 'Quality conversations' },
  { key: 'appset', label: 'Appts set' },
  { key: 'appshown', label: 'Shown' },
  { key: 'referrals', label: 'Referrals' },
  { key: 'sold', label: 'Sold' },
  { key: 'points', label: 'Points' },
];

const CALLS_COLUMN = { key: 'calls', label: 'Calls' };

// rows: [{ id, name, ...tally(), calls? }]. showCalls adds a Telzio calls column.
const StatTable = ({ rows, nameLabel = 'Name', defaultSort = 'points', showCalls = false }) => {
  const columns = showCalls ? [CALLS_COLUMN, ...STAT_COLUMNS] : STAT_COLUMNS;
  const [sort, setSort] = useState({ key: defaultSort, dir: 'desc' });

  const sorted = useMemo(() => {
    const dir = sort.dir === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
      if (sort.key === 'name') return dir * a.name.localeCompare(b.name);
      return dir * (a[sort.key] - b[sort.key]) || a.name.localeCompare(b.name);
    });
  }, [rows, sort]);

  const toggle = (key) => setSort((s) => ({
    key,
    dir: s.key === key ? (s.dir === 'desc' ? 'asc' : 'desc') : key === 'name' ? 'asc' : 'desc',
  }));

  const header = (key, label) => {
    const active = sort.key === key;
    return (
      <th key={key} className={active ? 'sorted' : ''}
        aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
        <button type="button" onClick={() => toggle(key)}>
          {label}{active ? (sort.dir === 'asc' ? ' ↑' : ' ↓') : ''}
        </button>
      </th>
    );
  };

  return (
    <div className="table-scroll">
      <table className="stat-table">
        <thead>
          <tr>
            {header('name', nameLabel)}
            {columns.map((c) => header(c.key, c.label))}
          </tr>
        </thead>
        <tbody>
          {sorted.map((r) => (
            <tr key={r.id}>
              <td>{r.name}</td>
              {columns.map((c) => (
                <td key={c.key} className={c.key === 'points' ? 'points' : ''}>{r[c.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StatTable;
